// extracted by mini-css-extract-plugin
module.exports = {"root":"homeAdv_root__1Lpg8","img":"homeAdv_img__18c2A"};